export default {
    // 报警事件信息查询接口
    getAlarmEvent(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmEvent', params, response);
    },
    // 报警级别信息查询接口
    getAlarmLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmLevel', params, response);
    },
    // 报警事件信息添加接口
    saveAlarmEvent(params, response) {
        if (params.isAddData) {
            window.vue.$apiAxios.postRequestBody('/alarm/addAlarmEvent', JSON.stringify(params), response);
        } else {
            window.vue.$apiAxios.postRequestBody('/alarm/updateAlarmEvent', JSON.stringify(params), response);
        }
    },
    // 报警事件信息删除接口
    deleteAlarmEvent(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/deleteAlarmEvent', params, response);
    },
    // 报警事件信息列表查询接口
    getAlarmEventAll(params, response) {
        window.vue.$apiAxios.get('/alarm/getAlarmEventAll', params, response);
    },
    // 批量修改报警事件类型
    updateAlarmEventType(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/updateAlarmEventType', params, response);
    },
    // 获取设备类型下拉列表
    getDeviceTypeList(params, response) {
        window.vue.$apiAxios.get('/alarm/getDeviceTypeList', params, response);
    },
    // 获取报警类型下拉树
    getAlarmTypeTree(params, response) {
        window.vue.$apiAxios.get('/alarm/getAlarmTypeTree', params, response);
    },
    // 校验编号/名称是否重复
    checkRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/checkAlarmEventRepeat', JSON.stringify(params), response);
    },
    //获取二级事件
    getAlarmEventSub(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarm/getAlarmEventSub', params, response);
    }
};
